import React from "react";
import toast from "react-hot-toast";
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";

const ConfirmationModal = ({ open, toggle, onConfirm, title, message }) => {
  const handleConfirm = async () => {
    try {
      await onConfirm(); // API call comes from parent
      toggle(); // Close modal after success
      toast.success("Order Completed")
    } catch (error) {
      console.error("Error while confirming:", error);
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle} centered scrollable backdrop={false} size="lg">
      <ModalHeader toggle={toggle} style={{backgroundColor:'#00ADF0', color:"white"}}>{title || "Confirmation"}</ModalHeader>
      <ModalBody style={{backgroundColor:'#00ADF0', color:"white"}}>
        <h5 style={{textAlign:"justify"}}>{message || "Are you sure you want to proceed?"}</h5>
        <Row className="mt-3">
          <Col className="text-center">
            <Button color="secondary" onClick={toggle} className="me-2">
              Cancel
            </Button>
            <Button color="secondary" onClick={handleConfirm}>
              Yes
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModal;
